/**
 * Aplica config de megamenus (desktop + drawer). Deve rodar com defer para o drawer estar no DOM.
 */
(function() {
    var runTimer;
    function run() {
      clearTimeout(runTimer);
      runTimer = setTimeout(function() {
        applyConfig();
        applyCards();
        initPanels();
      }, 0);
    }
    function applyConfig() {
      var el = document.getElementById('header-megamenus-config');
      if (!el) return;
      var config;
      try { config = JSON.parse(el.textContent || '[]'); } catch (e) { return; }
      if (!Array.isArray(config) || config.length === 0) return;
      function mark(node) {
        var h = (node.getAttribute('data-link-handle') || '').toLowerCase();
        var t = (node.getAttribute('data-link-title') || '').toLowerCase();
        var use = config.some(function(v) { v = (v || '').toLowerCase(); return v && (h === v || t === v); });
        if (use) node.setAttribute('data-use-megamenu', 'true');
      }
      document.querySelectorAll('.menu-list__submenu-inner--megamenu-config[data-link-handle]').forEach(mark);
      document.querySelectorAll('.menu-drawer__megamenu-config[data-link-handle]').forEach(mark);
      document.querySelectorAll('.menu-list__list-item[data-has-children="false"]').forEach(function(li) {
        var inner = li.querySelector('.menu-list__submenu-inner--megamenu-config');
        if (!inner || inner.getAttribute('data-use-megamenu') !== 'true') {
          var sub = li.querySelector('.menu-list__submenu');
          if (sub) sub.remove();
          var link = li.querySelector('a.menu-list__link');
          if (link) {
            link.classList.remove('menu-list__link--has-submenu');
            link.removeAttribute('aria-controls');
            link.removeAttribute('aria-haspopup');
            link.removeAttribute('aria-expanded');
            var ind = link.querySelector('.menu-list__submenu-indicator');
            if (ind) ind.remove();
          }
        }
      });
      var drawer = document.querySelector('header-drawer');
      var backRef = drawer ? drawer.querySelector('.menu-drawer__submenu .menu-drawer__back-button') : null;
      var closeRef = drawer ? drawer.querySelector('.menu-drawer__submenu .menu-drawer__close-button') : null;
      document.querySelectorAll('.menu-drawer__megamenu-config[data-use-megamenu="true"]').forEach(function(li) {
        var link = li.querySelector('a[data-megamenu-no-children-link]');
        var panelsWrap = li.querySelector('.menu-drawer__submenu-variant--megamenu-no-children');
        if (!link || !panelsWrap) return;
        var title = (link.querySelector('.menu-drawer__menu-item-text') || {}).textContent || '';
        var d = document.createElement('details');
        d.className = 'menu-drawer__details--megamenu-cards-only';
        var sum = document.createElement('summary');
        sum.className = typeof link.className === 'string' ? link.className : (link.className.baseVal || '');
        sum.setAttribute('id', link.getAttribute('id') || '');
        sum.setAttribute('on:click', 'header-drawer/open');
        if (link.getAttribute('data-highlighted')) sum.setAttribute('data-highlighted', link.getAttribute('data-highlighted'));
        if (link.getAttribute('style')) sum.setAttribute('style', link.getAttribute('style'));
        var ts = link.querySelector('.menu-drawer__menu-item-text');
        if (ts) sum.appendChild(ts.cloneNode(true));
        var ind = link.querySelector('.menu-drawer__submenu-indicator--megamenu-no-children');
        if (ind) {
          var ic = ind.cloneNode(true);
          ic.style.display = '';
          ic.classList.add('menu-drawer__submenu-indicator--forward');
          sum.appendChild(ic);
        }
        d.appendChild(sum);
        var sub = document.createElement('div');
        sub.className = 'menu-drawer__submenu has-submenu gradient motion-reduce';
        sub.setAttribute('tabindex', '-1');
        var inner = document.createElement('div');
        inner.className = 'menu-drawer__inner-submenu';
        var nav = document.createElement('div');
        nav.className = 'menu-drawer__nav-buttons';
        var backBtn = document.createElement('button');
        backBtn.type = 'button';
        backBtn.className = 'button menu-drawer__back-button focus-inset';
        backBtn.setAttribute('aria-expanded', 'true');
        backBtn.setAttribute('on:click', 'header-drawer/back');
        backBtn.setAttribute('aria-label', backRef ? (backRef.getAttribute('aria-label') || '') : '');
        if (backRef && backRef.firstElementChild) backBtn.appendChild(backRef.firstElementChild.cloneNode(true));
        var bt = document.createElement('span');
        bt.className = 'menu-drawer__menu-item-text wrap-text';
        bt.textContent = title;
        backBtn.appendChild(bt);
        nav.appendChild(backBtn);
        var closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'button close-button menu-drawer__close-button';
        closeBtn.setAttribute('aria-label', closeRef ? (closeRef.getAttribute('aria-label') || '') : '');
        closeBtn.setAttribute('on:click', 'header-drawer/close');
        if (closeRef && closeRef.firstElementChild) closeBtn.appendChild(closeRef.firstElementChild.cloneNode(true));
        nav.appendChild(closeBtn);
        inner.appendChild(nav);
        panelsWrap.style.display = '';
        panelsWrap.classList.remove('menu-drawer__submenu-variant--megamenu-no-children');
        inner.appendChild(panelsWrap);
        sub.appendChild(inner);
        d.appendChild(sub);
        link.replaceWith(d);
      });
    }
    function initPanels() {
      document.querySelectorAll('.mega-menu-panels').forEach(function(root) {
        if (root.hasAttribute('data-megamenu-panels-inited')) return;
        root.setAttribute('data-megamenu-panels-inited', 'true');
        var navItems = root.querySelectorAll('.mega-menu-panels__nav-item[data-panel-index]');
        var panels = root.querySelectorAll('.mega-menu-panels__middle-panel[data-panel-index]');
        var activeClass = 'is-active';
        function show(i) {
          var idx = parseInt(i, 10);
          if (isNaN(idx) || idx < 0) return;
          root.classList.add('has-middle-visible');
          panels.forEach(function(p) {
            var n = parseInt(p.getAttribute('data-panel-index'), 10);
            if (n === idx) { p.removeAttribute('hidden'); p.setAttribute('aria-hidden', 'false'); }
            else { p.setAttribute('hidden', ''); p.setAttribute('aria-hidden', 'true'); }
          });
          navItems.forEach(function(nav) {
            var link = nav.querySelector('.mega-menu-panels__nav-link');
            var n = parseInt(nav.getAttribute('data-panel-index'), 10);
            if (n === idx) { nav.classList.add(activeClass); if (link) link.setAttribute('aria-expanded', 'true'); }
            else { nav.classList.remove(activeClass); if (link) link.setAttribute('aria-expanded', 'false'); }
          });
        }
        function hide() {
          root.classList.remove('has-middle-visible');
          panels.forEach(function(p) { p.setAttribute('hidden', ''); p.setAttribute('aria-hidden', 'true'); });
          navItems.forEach(function(nav) {
            nav.classList.remove(activeClass);
            var link = nav.querySelector('.mega-menu-panels__nav-link');
            if (link) link.setAttribute('aria-expanded', 'false');
          });
        }
        navItems.forEach(function(nav) {
          var index = nav.getAttribute('data-panel-index');
          nav.addEventListener('mouseenter', function() { show(index); });
          nav.addEventListener('focusin', function() { show(index); });
        });
        root.addEventListener('mouseleave', hide);
      });
    }
    function applyCards() {
      var el = document.getElementById('header-megamenus-cards-settings');
      if (!el) return;
      var s;
      try { s = JSON.parse(el.textContent || '{}'); } catch (e) { return; }
      var global = s.global || {};
      var blocks = Array.isArray(s.blocks) ? s.blocks : [];
      var imageHeight = global.imageHeight || 280;
      function hasImg(card) {
        var img = card.querySelector('img.mega-menu-panels__card-image, img.mega-menu-panels-drawer-cards__image');
        return img && typeof img.src === 'string' && img.src.length > 5 && !img.src.startsWith('data:');
      }
      function setCount(wrap, cardEls) {
        var n = 0;
        cardEls.forEach(function(c) {
          if (hasImg(c)) { c.classList.remove('mega-menu-panels__card--empty'); c.style.display = ''; n++; }
          else { c.classList.add('mega-menu-panels__card--empty'); c.style.display = 'none'; }
        });
        if (wrap) wrap.setAttribute('data-visible-cards', String(n));
      }
      function applyToCards(cardEls, cards, wrap) {
        if (!cardEls || !cardEls.length) return;
        cardEls.forEach(function(card, idx) {
          var c = cards[idx];
          if (!c) return;
          if (c.link) card.setAttribute('href', c.link);
          var titleEl = card.querySelector('.mega-menu-panels__card-title, .mega-menu-panels-drawer-cards__title');
          var subEl = card.querySelector('.mega-menu-panels__card-subtitle, .mega-menu-panels-drawer-cards__subtitle');
          var imgEl = card.querySelector('img.mega-menu-panels__card-image, img.mega-menu-panels-drawer-cards__image');
          var place = card.querySelector('.mega-menu-panels__card-placeholder, .mega-menu-panels-drawer-cards__placeholder');
          if (c.title && titleEl) titleEl.textContent = c.title;
          if (c.subtitle && subEl) subEl.textContent = c.subtitle;
          if (c.image) {
            if (imgEl) { imgEl.src = c.image; if (imgEl.removeAttribute) imgEl.removeAttribute('srcset'); }
            else if (place) {
              var img = document.createElement('img');
              img.className = place.classList.contains('mega-menu-panels-drawer-cards__placeholder') ? 'mega-menu-panels-drawer-cards__image' : 'mega-menu-panels__card-image';
              img.src = c.image;
              img.alt = c.title || '';
              img.loading = 'lazy';
              place.parentNode.replaceChild(img, place);
            }
          }
        });
        if (wrap) setCount(wrap, cardEls);
      }
      var imageHeightMobile = global.imageHeightMobile || 180;
      var textPos = global.textPosition || 'below';
      document.querySelectorAll('.mega-menu-panels').forEach(function(panel) {
        panel.style.setProperty('--megamenus-cards-height', imageHeight + 'px');
        panel.setAttribute('data-text-position', textPos);
        var h = (panel.getAttribute('data-link-handle') || '').toLowerCase();
        var t = (panel.getAttribute('data-link-title') || '').toLowerCase();
        var cfg = blocks.find(function(b) {
          var item = (b.menuItem || '').toLowerCase();
          return item && (item === h || item === t);
        });
        panel.setAttribute('data-title-vertical', cfg && cfg.titleVertical ? 'true' : 'false');
        panel.setAttribute('data-title-vertical-position', (cfg && cfg.titleVertical && cfg.titleVerticalPosition) ? cfg.titleVerticalPosition : 'center');
        var cardsWrap = panel.querySelector('.mega-menu-panels__cards');
        var cardEls = cardsWrap ? cardsWrap.querySelectorAll('.mega-menu-panels__card') : [];
        if (cfg && cfg.cards) applyToCards(cardEls, cfg.cards, cardsWrap);
        else setCount(cardsWrap, cardEls);
      });
      document.querySelectorAll('.mega-menu-panels-drawer-cards').forEach(function(wrap) {
        wrap.style.setProperty('--megamenus-cards-height', imageHeightMobile + 'px');
        wrap.setAttribute('data-text-position', textPos);
        var h = (wrap.getAttribute('data-link-handle') || '').toLowerCase();
        var t = (wrap.getAttribute('data-link-title') || '').toLowerCase();
        var cfg = blocks.find(function(b) {
          var item = (b.menuItem || '').toLowerCase();
          return item && (item === h || item === t);
        });
        wrap.setAttribute('data-title-vertical', cfg && cfg.titleVertical ? 'true' : 'false');
        wrap.setAttribute('data-title-vertical-position', (cfg && cfg.titleVertical && cfg.titleVerticalPosition) ? cfg.titleVerticalPosition : 'center');
        wrap.setAttribute('data-mobile-layout', (cfg && cfg.mobileLayout) ? cfg.mobileLayout : 'carousel');
        wrap.setAttribute('data-mobile-cards-per-row', (cfg && cfg.mobileLayout === 'grid' && cfg.mobileCardsPerRow) ? String(cfg.mobileCardsPerRow) : '2');
        var list = wrap.querySelector('.mega-menu-panels-drawer-cards__list');
        var cardEls = list ? list.querySelectorAll('.mega-menu-panels-drawer-cards__card') : [];
        if (cfg && cfg.cards) applyToCards(cardEls, cfg.cards, list);
        else setCount(list, cardEls);
      });
    }
    function scheduleRun() {
      run();
      setTimeout(run, 150);
      setTimeout(run, 500);
      setTimeout(run, 1000);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        scheduleRun();
        var drawerEl = document.querySelector('header-drawer');
        if (drawerEl) {
          drawerEl.addEventListener('toggle', function(ev) {
            if (ev.target && ev.target.nodeName === 'DETAILS' && ev.target.open) setTimeout(run, 80);
          }, true);
          var mo = new MutationObserver(function() { setTimeout(run, 50); });
          mo.observe(drawerEl, { childList: true, subtree: true });
        }
      });
    } else {
      scheduleRun();
      var drawerEl = document.querySelector('header-drawer');
      if (drawerEl) {
        drawerEl.addEventListener('toggle', function(ev) {
          if (ev.target && ev.target.nodeName === 'DETAILS' && ev.target.open) setTimeout(run, 80);
        }, true);
        var mo = new MutationObserver(function() { setTimeout(run, 50); });
        mo.observe(drawerEl, { childList: true, subtree: true });
      }
    }
  })();
  